<div class="bg-white px-8 p-4 min-w-[35vw]">
  <div class="flex items-center justify-between">
    <div class="flex items-center space-x-2">
      <span class="material-icons-outlined text-danger text-3xl">info</span>
      <h1 class="text-red-500 font-semibold">Action Confirmation</h1>
    </div>
    <span
      matRipple
      mat-dialog-close
      class="material-icons-outlined text-gray-400 text-2xl hover:bg-gray-200 px-1 rounded-md"
      >close</span
    >
  </div>

  <form (submit)="handleSubmit($event)">
    <div class="mt-4 mb-1.5">
      <p class="text-sm mb-3">
        Enter <strong>{{ confirmationText }}</strong> to confirm this
        irreversible delete action:
      </p>
      <mat-form-field>
        <mat-label>Confirmation</mat-label>
        <input matInput [formControl]="confirmationControl" />
      </mat-form-field>
    </div>

    <div class="flex md:justify-end">
      <div class="grid grid-cols-1 md:grid-cols-2 gap-2 w-full md:w-auto">
        <button
          mat-stroked-button
          class="border border-secondary text-secondary hover:bg-secondary-50"
          (click)="handleCancel()"
        >
          Cancel
        </button>

        <button
          mat-button
          type="submit"
          class="bg-danger text-white"
          [ngClass]="[
            !canDelete ? 'cursor-not-allowed' : 'cursor-pointer',
            !canDelete
              ? 'hover:bg-gray-300 hover:text-gray-700 hover:opacity-50'
              : 'hover:bg-red-600'
          ]"
          [disabled]="!canDelete"
        >
          Confirm Delete
        </button>
      </div>
    </div>
  </form>
</div>
